import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "booking-sidebar" }

import { onBeforeMount, ref, inject } from "vue";
import { AxiosResponse } from "axios";
import { IBooking, ApiBaseReqParams } from "@/clinic/typings";
import { BookingActionEnum } from "@/clinic/typings/enums/booking";
import HeaderShowTemplate from "@/clinic/views/Booking/components/show/template/header.vue";
import BodyShowTemplate from "@/clinic/views/Booking/components/show/body.vue";
import { BookingServices } from "@/clinic/services";
import { get, set } from "@vueuse/core";
import Header from "../common/booking/header.vue";
import Body from "../common/booking/body.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingDetail',
  setup(__props, { expose }) {

const clinicId = ref(0);
const booking = ref<IBooking>();

const clinicIdParams = async (): Promise<ApiBaseReqParams> => ({
  clinic_id: get(await get(clinicId)),
  default_staff: "yes",
});

const onShow = async (bookingX: IBooking, action: BookingActionEnum) => {
  const loadBookingActions = [BookingActionEnum.show, BookingActionEnum.edit];
  if (loadBookingActions.includes(action)) await loadBooking(bookingX?.id);
};

const loadBooking = async (id: number) => {
  const { data: bookingData } = (await BookingServices.getBooking({
    id,
    ...(await clinicIdParams()),
  })) as unknown as AxiosResponse<IBooking>;

  let modifiedBookingData = { ...get(bookingData) };

  if (
    get(modifiedBookingData, "booking_request_status") !== "not_process" &&
    get(modifiedBookingData, "booking_type") === "request"
  ) {
    modifiedBookingData = { ...modifiedBookingData, booking_type: "normal" };
  }
  set(booking, modifiedBookingData);
};

// eslint-disable-next-line no-undef
expose({
  onShow,
  // onClose,
});
onBeforeMount(async () => set(clinicId, await inject("clinicId")));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, { booking: booking.value }, null, 8, ["booking"]),
    _createVNode(Body, { booking: booking.value }, null, 8, ["booking"])
  ]))
}
}

})